(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-page-CUSTOM-withdrawal"]) return;
  try {
    
/* Zweistufiges Widerrufsformular.
   Progressive Enhancement: ohne JS sind beide Schritte sichtbar und das Formular ist absendbar. */
(function () {
  var form = document.querySelector('[data-withdrawal-form]');
  if (!form) return;

  var step1 = form.querySelector('.withdrawal-step-1');
  var step2 = form.querySelector('.withdrawal-step-2');
  var nextBtn = form.querySelector('[data-withdrawal-next]');
  var backBtn = form.querySelector('[data-withdrawal-back]');
  var summary = form.querySelector('[data-withdrawal-summary]');
  var tsField = form.querySelector('#WdTimestamp');
  var scopeRadios = form.querySelectorAll('[name="contact[Zakres zwrotu]"]');
  var partialRadio = form.querySelector('[data-scope="partial"]');
  var productsWrap = form.querySelector('[data-withdrawal-products]');

  if (!step1 || !step2 || !nextBtn || !summary) return;

  // Erst wenn JS läuft, blenden wir Schritt 2 aus und aktivieren den zweistufigen Ablauf.
  step2.setAttribute('hidden', '');

  // Artikelfeld nur bei teilweisem Widerruf sichtbar (ohne JS bleibt es sichtbar).
  function syncProducts() {
    if (!productsWrap) return;
    if (partialRadio && partialRadio.checked) {
      productsWrap.removeAttribute('hidden');
    } else {
      productsWrap.setAttribute('hidden', '');
    }
  }
  Array.prototype.forEach.call(scopeRadios, function (r) {
    r.addEventListener('change', syncProducts);
  });
  syncProducts();

  function addSummaryRow(label, value) {
    if (!value) return;
    var dt = document.createElement('dt');
    dt.textContent = label;
    var dd = document.createElement('dd');
    dd.textContent = value;
    summary.appendChild(dt);
    summary.appendChild(dd);
  }

  nextBtn.addEventListener('click', function () {
    var inputs = step1.querySelectorAll('input, textarea');
    var valid = true;
    Array.prototype.forEach.call(inputs, function (el) {
      if (!el.checkValidity()) {
        el.reportValidity();
        valid = false;
      }
    });
    if (!valid) return;

    var locale = document.documentElement.lang || 'de';
    var stamp = new Date().toLocaleString(locale);
    if (tsField) tsField.value = stamp;

    var nameEl = document.getElementById('WdName');
    var orderEl = document.getElementById('WdOrder');
    var emailEl = document.getElementById('WdEmail');
    var productsEl = document.getElementById('WdProducts');
    var noteEl = document.getElementById('WdNote');
    var scopeEl = form.querySelector('[name="contact[Zakres zwrotu]"]:checked');

    summary.innerHTML = '';
    addSummaryRow('Vor- und Nachname', nameEl && nameEl.value);
    addSummaryRow('Bestellnummer', orderEl && orderEl.value);
    addSummaryRow('E-Mail-Adresse', emailEl && emailEl.value);
    addSummaryRow('Rückgabeumfang', scopeEl && scopeEl.value);
    addSummaryRow('Zu widerrufende Artikel', productsEl && productsEl.value);
    addSummaryRow('Zusätzliche Informationen', noteEl && noteEl.value);
    addSummaryRow('Datum und Uhrzeit der Erklärung', stamp);

    step1.setAttribute('hidden', '');
    step2.removeAttribute('hidden');
    step2.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  if (backBtn) {
    backBtn.addEventListener('click', function () {
      step2.setAttribute('hidden', '');
      step1.removeAttribute('hidden');
      step1.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
